import { Injectable } from '@angular/core';

import { TreeNode } from 'primeng/api';

import { JournodexGeographyModel } from '../../../Common/Journodex/models/journodex-geography.model';
import { JournodexRegionsService } from '../../../Common/Journodex/services/journodex-regions.service';
import { RegionSelectDialogService } from '../../../Common/Dialogs/services/region-select-dialog.service';
import { IncludeOrExclude } from '../../../Common/Dialogs/services/data-select-dialog.service.interface';

/**
 * This class is a service that handles fetching data on available regions and handles the logic for selecting
 * regions to be either included or excluded from a search.
 *
 * Three lists of regions need to be managed in this service:
 * 1. listItems -  the available regions to choose from
 * 2. flattenedSelectedRegions - an array listing all of the individual selected regions regardless of their relationship to other regions
 * 3. selectedListItems -  list of selected regions that contians only the highest level geographic regions (lists the parents, but not the children)
 *
 */
@Injectable()
export class MonitoringSearchRegionSelectDialogService extends RegionSelectDialogService {

    constructor(
        protected geographyService: JournodexRegionsService,
    ) {
        super(geographyService);
    }

    /**
     * Applies the selected region items to the searchQuery
     *
     * @param selectedItems the items selected in the component
     */
    applySelectedListItems(selectedItems: TreeNode[]): void {
        const newSelectedItems = this.filterOutNodeChildren(selectedItems);

        this.selectedRegions = [];
        for (const selectedItem of newSelectedItems) {
            this.selectedRegions.push(<JournodexGeographyModel>selectedItem.data);
        }
    }

    /**
     * Sets the appropriate list items for the services state
     */
    setAppropriateListItems(): void {
        if (this.state === undefined) {

            return;
        }

        if (!this.selectedRegions) {
            this.selectedRegions = [];
        } else {
            this.selectedRegions = this.selectedRegions.slice();
            this.setSelectedRegions(this.selectedRegions);
        }
    }

    prepareModelData(state: IncludeOrExclude, regions: JournodexGeographyModel[]) {
        this.selectedRegions = regions;
        this.setState(state);
    }
}
